import { useEffect, useState } from 'react';

export const useLoadScript = url => {
  const [status, setStatus] = useState(url ? 'loading' : 'idle');

  useEffect(() => {
    if (!url) {
      setStatus('idle');
      return;
    }

    // Comprueba si el script ya existe en el DOM para evitar duplicados
    let script = document.querySelector(`script[src="${url}"]`);

    if (!script) {
      // Crea el elemento script
      script = document.createElement('script');
      script.src = url;
      script.async = true; // Carga asíncronamente
      script.setAttribute('data-status', 'loading'); // Atributo para seguimiento
      document.body.appendChild(script); // Añade el script al body
    }

    // Manejadores de eventos para saber cuándo se carga o falla
    const setAttributeFromEvent = event => {
      script.setAttribute('data-status', event.type === 'load' ? 'ready' : 'error');
      setStatus(event.type === 'load' ? 'ready' : 'error');
    };

    script.addEventListener('load', setAttributeFromEvent);
    script.addEventListener('error', setAttributeFromEvent);

    // Función de limpieza para eliminar el script del DOM
    // Se ejecuta cuando el componente se desmonta o la URL cambia
    return () => {
      if (script) {
        script.removeEventListener('load', setAttributeFromEvent);
        script.removeEventListener('error', setAttributeFromEvent);
        // Opcional: elimina el script del DOM al desmontar, aunque una vez cargado,
        // su código permanece en memoria. Esto ayuda con la limpieza de elementos.
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      }
    };
  }, [url]); // Se ejecuta cada vez que la URL cambia

  return status;
};
